import styled from 'styled-components'

import { color, fontFamily } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

type InputProps = {
  preview?: boolean
}

export const CitiesInput = styled.div<InputProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 4.8rem;
  border-radius: 0.6rem;
  background-color: ${color.VERY_LIGHT_PINK};
  padding-left: 1.6rem;
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  color: ${(p) => (p.preview ? `${color.PUTTY}` : `${color.GREYISH_BROWN}`)};
  font-family: ${fontFamily.CATAMARAN};
  margin-top: 0;
  text-align: left;
`
